import React, { useCallback, useState } from 'react';
import AppLayout from '../../component/appLayout';
import { VercelCMDK } from '../../component/vercel/vercel';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import ModalCustom from '../../component/models/modal';
import { Headline, Icon, ModalHead } from '../../component/appLayout/styles';
import { ContactUsModal } from '../../component/models/contactUsmodal';
import { SuccessFullModal } from '../../component/models/contactUsmodal/successfullmessagemodal';
import { isMediaRecordingSupported } from '../../helpers/common';
import SnapRecordModal from '../../component/models/snapRecordModal';
import { BottomNavigation } from '../../component/bottomNavigation';
import UserModal from '../../component/models/userModal';
import CreateTaskModalV2 from '../../component/models/createTaskModal/createTaskModalV2';
import ResponsiveHeader from '../../component/responsiveHeader/header';
import CreateNewProjectModalV2 from '../../component/models/createNewProjectModal/createProjectModelV2';
const ResponsiveSearch: React.FC = () => {
  // States
  const [isOpenSnapModal, setIsOpenSnapModal] = useState(false);
  const [isOpenTaskModal, setIsOpenTaskModal] = useState(false);
  const [openContactUsModal, setOpenContactUsModal] = useState(false);
  const [isOpenProjectModal, setIsOpenProjectModal] = useState(false);
  const [isSuccessfullModalOpen, setIsSuccessfullModalOpen] = useState(false);
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);

  const openSnapModal = useCallback(() => {
    setIsOpenSnapModal(true);
  }, []);

  const onClickCreateProject = useCallback(() => {
    setIsOpenProjectModal(true);
  }, []);

  const onClickCreateTask = useCallback(() => {
    setIsOpenTaskModal(true);
  }, []);

  const closeProjectModal = useCallback(() => {
    setIsOpenProjectModal(false);
  }, []);

  const closeTaskModal = useCallback(() => {
    setIsOpenTaskModal(false);
  }, []);

  const onCloseContactUsModal = useCallback(() => {
    setOpenContactUsModal(false);
  }, []);

  const onCloseSuccessfullModal = useCallback(() => {
    setIsSuccessfullModalOpen(false);
  }, []);

  const closeSnapModal = useCallback(() => {
    setIsOpenSnapModal(false);
  }, []);

  const onClickUserPopup = useCallback(() => {
    setIsOpenUserModal(true);
  }, []);

  const onCloseUserModal = useCallback(() => {
    setIsOpenUserModal(false);
  }, []);
  return (
    <>
      <AppLayout>
        <ResponsiveHeader Title='Search' />
        <VercelCMDK
          openSnapModal={openSnapModal}
          openProjectModal={onClickCreateProject}
          openTaskModal={onClickCreateTask}
          setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)}
          isSearchScreen
          openUserModal={onClickUserPopup}
        />
      </AppLayout>
      <ModalCustom open={isOpenProjectModal} onClose={closeProjectModal} width={632}>
        <ModalHead>
          <Headline>Create New Project</Headline>
          <Icon onClick={closeProjectModal}>
            <SVGIcon name='close-icon' width='18' height='18' viewBox='0 0 18 18' fill='none' className='svgicon' />
          </Icon>
        </ModalHead>
        <CreateNewProjectModalV2 handleCloseModal={closeProjectModal} onClickCancel={closeProjectModal} />
      </ModalCustom>
      <ModalCustom open={isOpenTaskModal} onClose={closeTaskModal} isCreateTask={true}>
        <CreateTaskModalV2 onCancel={closeTaskModal} isFromShortcut={true} />
      </ModalCustom>
      <ModalCustom open={openContactUsModal} onClose={onCloseContactUsModal} width={500}>
        <ContactUsModal
          openSuccessFullModal={() => setIsSuccessfullModalOpen(true)}
          closeContactUsModal={() => setOpenContactUsModal(false)}
        />
      </ModalCustom>
      <ModalCustom open={isSuccessfullModalOpen} onClose={onCloseSuccessfullModal} width={500}>
        <SuccessFullModal onClose={onCloseSuccessfullModal} />
      </ModalCustom>
      {isMediaRecordingSupported() && (
        <ModalCustom open={isOpenSnapModal} onClose={closeSnapModal} width={258} isZindex={true}>
          <SnapRecordModal handleCloseModal={closeSnapModal} />
        </ModalCustom>
      )}
      <ModalCustom open={isOpenUserModal} onClose={onCloseUserModal} width={280}>
        <UserModal onClose={onCloseUserModal} />
      </ModalCustom>
      {/* bottom navigation bar */}
      <BottomNavigation />
    </>
  );
};

export default ResponsiveSearch;
